import { Client } from '@pusher/push-notifications-web';
import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { User } from 'src/app/modals/Authentication/auth.models';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

//This should only be imported within topbar and called init and no where else
export class PushNotificationService {

  private currentUser: User | null;

  constructor(
    private localStorageService: LocalStorageService
  ) {
    this.currentUser = this.localStorageService.getItem('currentUser');
  }

  joinTaskPushNotification(): void {

    const clubId = this.currentUser?.club_id;
    // if (!clubId || this.isSubscribed) return;
    if (!clubId) return;

    const channelName = environment.env +"-client-"+`task${clubId}`;
    
    if ('serviceWorker' in navigator) {
      
      navigator.serviceWorker.ready.then((swReg) => {

        const beamsClient = new Client({
          instanceId: environment.pusher.beamInstanceId,
          serviceWorkerRegistration: swReg
        });

        if (!(window as any).beamsInitialized) {
          (window as any).beamsInitialized = true;

          beamsClient.start()
            .then(() => beamsClient.clearDeviceInterests()) // avoid duplicate subscriptions
            .then(() => beamsClient.addDeviceInterest(channelName))
            // .then(() => console.log(`Subscribed to `+channelName))
            .catch(err => console.error('Beams error:', err));
        }

      })
      .catch(err => console.error('Service Worker registration failed:', err));
    }
  }
}